import { useSelector } from "react-redux";

function SideBar({ settingsPage, setSettingsPage }) {
  const showSideBar = useSelector((state) => state.showSideBar.value);
  return (
    <div className="col-12 col-md-3">
      <div className="card card-bleed border-bottom border-bottom-md-0 shadow-light-lg">
        <div
          className={`collapse d-md-block ${showSideBar ? "show" : ""}`}
          id="sidenavCollapse"
        >
          <div className="card-body">
            <h6 className="fw-bold text-uppercase mb-3">Account</h6>

            <ul className="card-list list text-gray-700 mb-6">
              <li
                className={`list-item ${
                  settingsPage === "general" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("general")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">General</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "security" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("security")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">Security</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "kyc" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("kyc")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">KYC</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "transaction-pin" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("transaction")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">Transaction Pin</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "referrals" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("referrals")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">Referrals</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "statement" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("statement")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">Generate Statement</span>
              </li>
              <li
                className={`list-item ${
                  settingsPage === "more" ? "active" : ""
                }`}
                onClick={() => setSettingsPage("more")}
                style={{ cursor: "pointer" }}
              >
                <span className="list-link text-reset">More</span>
              </li>
            </ul>
            {showSideBar ? (
              <div className="col-auto">
                <a href="/dashboard" className="btn btn-sm btn-outline-primary">
                  Back to Dashboard
                </a>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
